var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.985 0.358892C11.2749 -0.115499 11.9621 -0.120572 12.259 0.349486L16.5773 7.18677L23.3662 8.25871C23.9302 8.34776 24.1918 9.00924 23.8413 9.45992L18.8023 15.9386L20.2349 23.1016C20.356 23.707 19.7345 24.1912 19.1771 23.9258L11.6417 20.3375L4.84963 23.9123C4.29095 24.2064 3.64113 23.7207 3.76495 23.1016L5.19755 15.9386L0.158571 9.45992C-0.179437 9.02534 0.050418 8.38682 0.587862 8.26739L7.02641 6.8366L10.985 0.358892ZM11.6354 2.171L7.97393 8.16255L2.0701 9.47451L6.80296 15.5596L5.54456 21.8516L11.6081 18.6602L18.4706 21.9281L17.1969 15.5596L21.8772 9.54209L15.6721 8.56233L11.6354 2.171Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.a60c0e96031f9622f7c18dfb994f56ed.svg";
export { ForwardRef as ReactComponent };